import Prism from 'prismjs/prism.js';
Prism.plugins.autoloader.languages_path = craft.env.assetsSiteUrl + '/assets/js/common/prismjs/components/';
import PrismAutoloader from 'prismjs/plugins/autoloader/prism-autoloader.min.js';
import AsideControls from "../../../components/aside-controls";
import Toc from "../../components/toc";
import { WikiTocMobile } from "../../components/wiki-toc-mobile";
import PhotoGallery from "../../../components/base/photo-gallery";

export default class PageModule {
    constructor() {
        this.initToc();
        this.initAsideControls();
        this.initPhotoGallery();
    }

    initToc() {
        const toc = new Toc(null, WikiTocMobile);
    }

    initAsideControls() {
        const asideControls = new AsideControls();
    }

    initPhotoGallery() {
        const photoGallery = new PhotoGallery();
    }
}